import { useEffect, useState, FC, useRef } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useVrmSaleSoDetailModel } from "../vrmBillSaleSoModel"
import useGlobalModel from '@/model/globalModel'
import { DictCodeEnmu } from '@/types/FmsDictEnums';
import TextPriviewImage from "@/components/Custom/TextPriviewImage";
import { invoiceModel } from "@/views/invoice/manage/InvoiceModel";

export const FormBox: FC<RouterParamType> = () => {
    const {
        detailLookForm,
        getDetailEditOne,
        resetLookCatch,
    } = useVrmSaleSoDetailModel();
    const formRef = useRef<IYhFormRef>();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id } = detailsInfo
    const { getSelectedDict } = useGlobalModel(model => []);
    const { imageUrl } = invoiceModel();

    useEffect(() => {
        getDetailEditOne(id)
    }, [id])
    useEffect(() => {
        return () => {
            resetLookCatch();
        }
    }, [selectedNavId])

    const title = <>
        <span>基础信息</span>

    </>
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售单号",
                fieldName: "saleCode",
                disable: true,
                placeholder: "自动生成"
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: '客户名称',
                fieldName: "customerName",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售类型",
                fieldName: "salesTypeName",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "售价选择",
                fieldName: "priceTypeName",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方",
                fieldName: "settlementPartyName",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算类型",
                fieldName: "payType",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityName",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 12,
                labelCol: { span: 3 },
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '客户地址',
                fieldName: 'address',
                span: 5,
                labelCol: { offset: 1 },
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                fieldName: "none",
                span: 1,
                labelCol: { offset: 5 },
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '附件',
                fieldName: 'fileName',
                fieldMd5: 'md5',
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                allowClear: true,
                fieldLabel: '销售人员',
                fieldName: 'saleUser',
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '财务备注',
                fieldName: 'fmsNote',
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: '客户类型',
                fieldName: 'customerTypeName',
                hidden: more,
                options: getSelectedDict(DictCodeEnmu.CUSTOMER_TYPE),
                disable: true,
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: '车辆类型',
                fieldName: 'vehicleTypeName',
                disable: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '车辆牌照',
                fieldName: 'licensePlate',
                allowClear: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: 'VIN码',
                fieldName: 'vin',
                allowClear: true,
                showSearch: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '所属机构',
                fieldName: 'shopName',
                disable: true,
                hidden: more,
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a style={{ color: 'black' }}>发票号码：</a>,
                fieldName: "none",
                hidden: more,
                span: 2,
                labelCol: { offset: 10 },
            },
            {
                type: FormItemTypeEnum.Button,
                fieldLabel: detailLookForm.invoiceNum ? <TextPriviewImage text={detailLookForm.invoiceNum} previewList={detailLookForm.invoiceMd5?.split(",")} imageUrl={imageUrl} /> : '',
                fieldName: "invoiceNum",
                hidden: more,
                span: 4,
                labelCol: { offset: 1 },
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '发票类型',
                fieldName: 'invoiceTypeName',
                allowClear: true,
                showSearch: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票人",
                fieldName: "invoiceOperator",
                hidden: more,
                disable: true,
                placeholder: "自动带出",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票上传时间",
                fieldName: "invoiceUploadTime",
                hidden: more,
                disable: true,
                placeholder: "自动带出",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '制单人',
                fieldName: 'createUser',
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '制单时间',
                fieldName: 'createTime',
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '库管员',
                fieldName: 'storekeeper',
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '出库时间',
                fieldName: 'stockIoTime',
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '结算员',
                fieldName: 'reckoner',
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '结算时间',
                fieldName: 'settleTime',
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '核销时间',
                fieldName: 'writeOffTime',
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '销售时间',
                showTime: true,
                fieldName: 'saleTime',
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "订单来源",
                fieldName: "orderSourceName",
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '收货人',
                fieldName: 'consignee',
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '收货电话',
                fieldName: 'consigneePhone',
                disable: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '收货地址',
                fieldName: 'consigneeAddress',
                disable: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '单据编号',
                fieldName: 'orderCode',
                disable: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '单据类型',
                fieldName: 'orderTypeName',
                disable: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '付款时间',
                fieldName: 'payTime',
                hidden: more,
                disable: true,
            }
        ]
    };

    const poFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: true,
        formValues: detailLookForm,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}